import { RootState } from "@/store/store";
import { explainWithAIAnomaliesSummaryDataSelector } from "@/store/explain-with-ai/selectors/data/anomalies-summary/explainWithAIAnomaliesSummaryDataSelector";

export const explainWithAIAnomaliesSummaryAnomaliesSelector = (
  state: RootState,
) => {
  return (
    explainWithAIAnomaliesSummaryDataSelector(state)?.anomalies ?? undefined
  );
};
